// Actions

import axios from '@/axios.js'

export default {
  GetList({commit}, params) {
    console.log(params,"<-----------------params")
    return new Promise((resolve, reject) => {
      axios({
        url: '/did/company/list',
        params,
        method: 'GET'
      })
      .then(res => {
        resolve(res.data.payload)
      })
      .catch(err => {
        reject(err)
      })
    })
  },
  GetList1({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/did/company/list',
        params,
        method: 'GET'
      })
      .then(res => {
        resolve(res.data.payload)
      })
      .catch(err => {
        reject(err)
      })
    })
  },
  GetDid ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios({
        url: `/did/${payload}`,
        method: 'GET'
      })
      .then(res => {
        if (res.data) {
          resolve(res.data)
        }
      })
      .catch(err => reject(err))
    })
  },
  Add({ commet }, payload) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/did',
        data: payload,
        method: 'POST'
      })
      .then(res => {
        if (res.data) {
          resolve(res.data)
        }
      })
      .catch(err => reject(err))
    })
  },
  Edit({ commet }, payload) {
    return new Promise((resolve, reject) => {
      axios({
        url: `/did/${payload.id}`,
        data: payload.data,
        method: 'PATCH'
      })
      .then(res => {
        if (res.data) {
          resolve(res.data)
        }
      })
      .catch(err => reject(err))
    })
  },
  Delete({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios({
        url: `/did/${payload}`,
        method: 'DELETE'
      })
      .then(res => {
        if (res.data.success) {
          resolve()
        }
      })
      .catch(err => reject(err))
    })
  },
  MassDelete ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/did/mass_delete',
        data: payload,
        method: 'DELETE'
      })
      .then(res => {
        if (res.data.success) {
          resolve()
        }
      })
      .catch(err => reject(err))
    })
  },
  GetSearchedDid({ commit }, id) {
    return new Promise(resolve => {
      axios({
        url: "/did/" + id,
        method: "GET"
      }).then(res => {
        resolve(res.data.payload);
      });
    });
  },
  getCountryList({ commit }, params) {
    return new Promise(resolve => {
      axios({
        url: "/country/list",
        params: {
          order_by: 'nice_name',
          order_dir: 'asc',
          per_page: params.per_page ?  params.per_page : 1000,
          nice_name: params.nice_name || ''
        },
        method: "GET"
      }).then(res => {
        resolve(res.data.payload);
      });
    });
  },
  GetCompanyList({ commit }, list) {
    return new Promise((resolve) => {
      axios({
        url: "/company/list?order_by=created_on&order_dir=desc",
        params: {
          page: list && list.page ? list.page : "",
          company_name:
            list && list.company_name ? "*" + list.company_name + "*" : "",
          company_uuid: list.company_uuid || '',
          reseller_uuid: list.reseller_uuid || '',
          reseller_name: list && list.reseller ? list.reseller : "",
          is_below_credit_limit:
            list && list.is_below_credit_limit
              ? list.is_below_credit_limit
              : "",
          payment_term_uuid:
            list && list.paymentTermId ? list.paymentTermId : "",
          per_page: list && list.per_page ? list.per_page : 10000,
          status: list.is_active ? "active" : '',
          prepay: list.prepay
        },
        method: "GET",
      }).then((res) => {
        resolve(res.data.payload);
      });
    });
  },
  EditDid({ commit }, did) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/did/" + did.did,
        data: did.newDid,
        method: "PATCH"
      }).then(res => {
        resolve(res.data.payload);
      }).catch(err => {
        reject(err.response.data);
      });
    });
  },
  GetImportLogList({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/did/kannel/import/log',
        params,
        method: 'GET'
      })
      .then(res => {
        resolve(res.data.payload)
      })
      .catch(err => {
        reject(err)
      })
    })
  },
  ImportDid ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const form_data = new FormData()

      for (let key in payload) {
        form_data.append(key, payload[key])
      }

      axios({
        url: '/did/kannel/import',
        data: form_data,
        method: 'POST'
      })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err)
      })
    })
  }
}
